import { render, staticRenderFns } from "./CustomerPayments.vue?vue&type=template&id=62c3c73f&scoped=true&"
import script from "./CustomerPayments.vue?vue&type=script&lang=js&"
export * from "./CustomerPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3c73f",
  null
  
)

export default component.exports